import {useParams} from 'react-router-dom';
import {useGetProject} from 'api/generated';
import {NoCodeRenderer} from 'components/no-code';
import {useTitle} from 'hooks';

interface IPageAR {}

const PageAR = ({}: IPageAR) => {
  useTitle('AR');

  const params = useParams();
  const handle = params.handle ?? '';
  const slug = params.project ?? '';

  const {data: projectData, isPending} = useGetProject(slug, {handle}, {query: {enabled: !!handle && !!slug}});
  const project = projectData?.data?.data;

  return <NoCodeRenderer projectState="live" project={project} isPending={isPending} />;
};

export default PageAR;
